import BaseStore from '@src/utils/store/base-store';
import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import message from '@src/components/common-message';

class MainStore extends BaseStore {
  @observable contentId = '';

  // // 文章标题
  @observable article_title = '';

  // 文章内容
  @observable content = '';

  @observable lang = '';

  /**
   * 获取文章详细信息
   * @param {string} contentId - 文章ID
   */
  getArticleDetail = async (contentId, lang) => {
    try {
      const { content } = await this.$ztService.getArticleDetail({ contentId, lang });

      // /**
      //  * 设置文章标题
      //  * @param {string} title - 文章标题
      //  */
      this.article_title = content.title;
      // /**
      //  * 设置文章内容
      //  * @param {string} content - 文章内容
      //  */
      this.content = content.content;
    } catch (error) {
      message.fail(error?.message);
    }
  };

  use() {
    super.use();
    const urlParams = new URLSearchParams(window.location.search);
    this.contentId = urlParams.get('contentId');
    this.lang = urlParams.get('lang');
    useMount(() => {
      // 测试contentID: slsaa5curksh
      if (this.contentId && this.lang) {
        this.getArticleDetail(this.contentId, this.lang);
      } else {
        message.fail('no data', 3000);
      }
    });
  }
}

export default MainStore;
